import NewCourtCases from './NewCourtCases/index';

export default NewCourtCases; 